var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import copy from 'copy-to-clipboard';
import { parse, print } from 'graphql'; // $FlowFixMe: can't find module

import CodeMirror from 'codemirror';

function formatVariableName(name) {
  var uppercasePattern = /[A-Z]/g;
  return name.charAt(0).toUpperCase() + name.slice(1).replace(uppercasePattern, '_$&').toUpperCase();
}

var copyIcon = React.createElement('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '20',
  height: '20',
  viewBox: '0 0 24 24'
}, React.createElement('path', {
  fill: 'none',
  d: 'M0 0h24v24H0V0z'
}), React.createElement('path', {
  d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z'
})); // TODO: Need clearer separation between option defs and option values

var operationNodesMemo = [null, null];

function getOperationNodes(query) {
  if (operationNodesMemo[0] === query && operationNodesMemo[1]) {
    return operationNodesMemo[1];
  }

  var operationDefinitions = [];

  try {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = parse(query).definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var def = _step.value;

        if (def.kind === 'OperationDefinition' && def.operation !== 'subscription') {
          operationDefinitions.push(def);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } catch (e) {}

  operationNodesMemo = [query, operationDefinitions];
  return operationDefinitions;
}

var getUsedVariables = function getUsedVariables(variables, operationDefinition) {
  return (operationDefinition.variableDefinitions || []).reduce(function (usedVariables, variable) {
    var variableName = variable.variable.name.value;

    if (variables[variableName]) {
      usedVariables[variableName] = variables[variableName];
    }

    return usedVariables;
  }, {});
};

var getOperationName = function getOperationName(operationDefinition) {
  return operationDefinition.name ? operationDefinition.name.value : operationDefinition.operation;
};

var getOperationDisplayName = function getOperationDisplayName(operationDefinition) {
  return operationDefinition.name ? operationDefinition.name.value : '<Unnamed:' + operationDefinition.operation + '>';
};
/**
 * ToolbarMenu
 *
 * A menu style button to use within the Toolbar.
 * Copied from GraphiQL: https://github.com/graphql/graphiql/blob/272e2371fc7715217739efd7817ce6343cb4fbec/src/components/ToolbarMenu.js#L16-L80
 */


export var ToolbarMenu = function (_Component) {
  _inherits(ToolbarMenu, _Component);

  function ToolbarMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToolbarMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToolbarMenu.__proto__ || Object.getPrototypeOf(ToolbarMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _this.handleOpen = function (e) {
      e.preventDefault();

      _this.setState({
        visible: true
      });

      _this._subscribe();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToolbarMenu, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._release();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var visible = this.state.visible;
      return React.createElement('a', {
        className: 'toolbar-menu toolbar-button',
        onClick: this.handleOpen,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        ref: function ref(node) {
          _this2._node = node;
        },
        title: this.props.title
      }, this.props.label, React.createElement('svg', {
        width: '14',
        height: '8'
      }, React.createElement('path', {
        fill: '#666',
        d: 'M 5 1.5 L 14 1.5 L 9.5 7 z'
      })), React.createElement('ul', {
        className: 'toolbar-menu-items' + (visible ? ' open' : '')
      }, this.props.children));
    }
  }, {
    key: '_subscribe',
    value: function _subscribe() {
      if (!this._listener) {
        this._listener = this.handleClick.bind(this);
        document.addEventListener('click', this._listener);
      }
    }
  }, {
    key: '_release',
    value: function _release() {
      if (this._listener) {
        document.removeEventListener('click', this._listener);
        this._listener = null;
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      if (this._node !== e.target) {
        e.preventDefault();
        this.setState({
          visible: false
        });

        this._release();
      }
    }
  }]);

  return ToolbarMenu;
}(Component);

var CodeDisplay = function (_React$PureComponent) {
  _inherits(CodeDisplay, _React$PureComponent);

  function CodeDisplay() {
    _classCallCheck(this, CodeDisplay);

    return _possibleConstructorReturn(this, (CodeDisplay.__proto__ || Object.getPrototypeOf(CodeDisplay)).apply(this, arguments));
  }

  _createClass(CodeDisplay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.editor = CodeMirror(this._node, {
        value: this.props.code.trim(),
        lineNumbers: false,
        mode: this.props.mode,
        readOnly: true,
        theme: this.props.theme
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.code !== prevProps.code) {
        this.editor.setValue(this.props.code);
      }

      if (this.props.mode !== prevProps.mode) {
        this.editor.setOption('mode', this.props.mode);
      }

      if (this.props.theme !== prevProps.theme) {
        this.editor.setOption('theme', this.props.theme);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return React.createElement('div', {
        ref: function ref(_ref2) {
          return _this4._node = _ref2;
        }
      });
    }
  }]);

  return CodeDisplay;
}(React.PureComponent);

var CodeExporter = function (_Component2) {
  _inherits(CodeExporter, _Component2);

  function CodeExporter() {
    var _ref3;

    var _temp2, _this5, _ret2;

    _classCallCheck(this, CodeExporter);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref3 = CodeExporter.__proto__ || Object.getPrototypeOf(CodeExporter)).call.apply(_ref3, [this].concat(args))), _this5), _this5.state = {
      showCopiedTooltip: false,
      optionValuesBySnippet: new Map(),
      snippet: null
    }, _this5._activeSnippet = function () {
      return _this5.props.snippet || _this5.state.snippet || _this5.props.snippets[0];
    }, _this5.setSnippet = function (snippet) {
      _this5.props.onSelectSnippet && _this5.props.onSelectSnippet(snippet);

      _this5.setState({
        snippet: snippet
      });
    }, _this5.setLanguage = function (language) {
      var snippet = _this5.props.snippets.find(function (snippet) {
        return snippet.language === language;
      });

      if (snippet) {
        _this5.setSnippet(snippet);
      }
    }, _this5.handleSetOptionValue = function (snippet, id, value) {
      _this5.props.onSetOptionValue && _this5.props.onSetOptionValue(snippet, id, value);
      var optionValuesBySnippet = _this5.state.optionValuesBySnippet;
      var snippetOptions = optionValuesBySnippet.get(snippet) || {};
      optionValuesBySnippet.set(snippet, _extends({}, snippetOptions, _defineProperty({}, id, value)));
      return _this5.setState({
        optionValuesBySnippet: optionValuesBySnippet
      });
    }, _this5.getOptionValues = function (snippet) {
      var snippetDefaults = snippet.options.reduce(function (acc, option) {
        return _extends({}, acc, _defineProperty({}, option.id, option.initial));
      }, {});
      return _extends({}, snippetDefaults, _this5.state.optionValuesBySnippet.get(snippet) || {}, _this5.props.optionValues);
    }, _temp2), _possibleConstructorReturn(_this5, _ret2);
  }

  _createClass(CodeExporter, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          serverUrl = _props.serverUrl,
          query = _props.query,
          snippets = _props.snippets,
          _props$context = _props.context,
          context = _props$context === undefined ? {} : _props$context,
          _props$variables = _props.variables,
          variables = _props$variables === undefined ? {} : _props$variables,
          _props$headers = _props.headers,
          headers = _props$headers === undefined ? {} : _props$headers;
      var showCopiedTooltip = this.state.showCopiedTooltip;

      var snippet = this._activeSnippet();

      var operationDefinitions = getOperationNodes(query);
      var name = snippet.name,
          language = snippet.language,
          generate = snippet.generate;
      var operationDataList = operationDefinitions.map(function (operationDefinition) {
        return {
          query: print(operationDefinition),
          name: getOperationName(operationDefinition),
          displayName: getOperationDisplayName(operationDefinition),
          type: operationDefinition.operation,
          variableName: formatVariableName(getOperationName(operationDefinition)),
          variables: getUsedVariables(variables, operationDefinition),
          operationDefinition: operationDefinition
        };
      });
      var optionValues = this.getOptionValues(snippet);
      var codeSnippet = operationDefinitions.length ? generate({
        serverUrl: serverUrl,
        headers: headers,
        context: context,
        operationDataList: operationDataList,
        options: optionValues
      }) : null;
      var languages = [].concat(_toConsumableArray(new Set(snippets.map(function (snippet) {
        return snippet.language;
      })))).sort(function (a, b) {
        return a.localeCompare(b);
      });
      return React.createElement('div', {
        className: 'graphiql-code-exporter',
        style: {
          minWidth: 410
        }
      }, React.createElement('div', {
        style: {
          fontFamily: 'system, -apple-system, San Francisco, Helvetica Neue, arial, sans-serif'
        }
      }, React.createElement('div', {
        style: {
          padding: '12px 7px 8px'
        }
      }, React.createElement(ToolbarMenu, {
        label: language,
        title: 'Language'
      }, languages.map(function (lang) {
        return React.createElement('li', {
          onClick: function onClick() {
            return _this6.setLanguage(lang);
          }
        }, lang);
      })), React.createElement(ToolbarMenu, {
        label: name,
        title: 'Mode'
      }, snippets.filter(function (snippet) {
        return snippet.language === language;
      }).map(function (snippet) {
        return React.createElement('li', {
          onClick: function onClick() {
            return _this6.setSnippet(snippet);
          }
        }, snippet.name);
      }))), snippet.options.length > 0 ? React.createElement('div', {
        style: {
          padding: '0px 11px 10px'
        }
      }, React.createElement('div', {
        style: {
          fontWeight: 700,
          color: 'rgb(177, 26, 4)',
          fontVariant: 'small-caps',
          textTransform: 'lowercase'
        }
      }, 'Options'), snippet.options.map(function (option) {
        return React.createElement('div', {
          key: option.id
        }, React.createElement('input', {
          id: option.id,
          type: 'checkbox',
          style: {
            position: 'relative',
            top: -1
          },
          checked: optionValues[option.id],
          onChange: function onChange() {
            return _this6.handleSetOptionValue(snippet, option.id, !optionValues[option.id]);
          }
        }), React.createElement('label', {
          'for': option.id,
          style: {
            paddingLeft: 5
          }
        }, option.label));
      })) : React.createElement('div', {
        style: {
          minHeight: 8
        }
      })), React.createElement('button', {
        className: 'toolbar-button',
        style: {
          fontSize: '1.2em',
          padding: 0,
          position: 'absolute',
          left: 340,
          marginTop: -20,
          width: 40,
          height: 40,
          backgroundColor: 'white',
          borderRadius: 40,
          border: 'none',
          outline: 'none'
        },
        type: 'link',
        onClick: function onClick() {
          copy(codeSnippet);

          _this6.setState({
            showCopiedTooltip: true
          }, function () {
            return setTimeout(function () {
              return _this6.setState({
                showCopiedTooltip: false
              });
            }, 450);
          });
        }
      }, React.createElement('div', {
        style: {
          position: 'absolute',
          top: '-30px',
          left: '-15px',
          fontSize: 'small',
          padding: '6px 8px',
          color: '#fff',
          textAlign: 'left',
          textDecoration: 'none',
          wordWrap: 'break-word',
          backgroundColor: 'rgba(0,0,0,0.75)',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: showCopiedTooltip ? 'block' : 'none'
        },
        pointerEvents: 'none'
      }, 'Copied!'), copyIcon), React.createElement('div', {
        style: {
          padding: '15px 12px',
          margin: 0,
          borderTop: '1px solid rgb(220, 220, 220)',
          fontSize: 12
        }
      }, codeSnippet ? React.createElement(CodeDisplay, {
        code: codeSnippet,
        mode: snippet.codeMirrorMode,
        theme: this.props.codeMirrorTheme
      }) : React.createElement('div', null, 'The query is invalid.', React.createElement('br', null), 'The generated code will appear here once the errors in the query editor are resolved.')));
    }
  }]);

  return CodeExporter;
}(Component);

var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _ref4;

    var _temp3, _this7, _ret3;

    _classCallCheck(this, ErrorBoundary);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this7 = _possibleConstructorReturn(this, (_ref4 = ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref4, [this].concat(args))), _this7), _this7.state = {
      hasError: false
    }, _temp3), _possibleConstructorReturn(_this7, _ret3);
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({
        hasError: true
      });
      console.error('Error in component', error, info);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.hasError) {
        return React.createElement('div', {
          style: {
            fontFamily: 'sans-serif'
          },
          className: 'error-container'
        }, 'Error generating code. Please', ' ', React.createElement('a', {
          href: 'https://spectrum.chat/onegraph',
          target: '_blank',
          rel: 'noreferrer noopener'
        }, 'report your query on Spectrum'), '.');
      }

      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(React.Component); // we borrow class names from graphiql's CSS as the visual appearance is the same
// yet we might want to change that at some point in order to have a self-contained standalone


export default function CodeExporterWrapper(_ref5) {
  var query = _ref5.query,
      serverUrl = _ref5.serverUrl,
      variables = _ref5.variables,
      _ref5$context = _ref5.context,
      context = _ref5$context === undefined ? {} : _ref5$context,
      _ref5$headers = _ref5.headers,
      headers = _ref5$headers === undefined ? {} : _ref5$headers,
      _ref5$hideCodeExporte = _ref5.hideCodeExporter,
      hideCodeExporter = _ref5$hideCodeExporte === undefined ? function () {} : _ref5$hideCodeExporte,
      snippets = _ref5.snippets,
      snippet = _ref5.snippet,
      codeMirrorTheme = _ref5.codeMirrorTheme,
      onSelectSnippet = _ref5.onSelectSnippet,
      onSetOptionValue = _ref5.onSetOptionValue,
      optionValues = _ref5.optionValues;
  var jsonVariables = {};

  try {
    var parsedVariables = JSON.parse(variables);

    if ((typeof parsedVariables === 'undefined' ? 'undefined' : _typeof(parsedVariables)) === 'object') {
      jsonVariables = parsedVariables;
    }
  } catch (e) {}

  return React.createElement('div', {
    className: 'historyPaneWrap',
    style: {
      width: 440,
      minWidth: 440,
      zIndex: 7
    }
  }, React.createElement('div', {
    className: 'history-title-bar'
  }, React.createElement('div', {
    className: 'history-title'
  }, 'Code Exporter'), React.createElement('div', {
    className: 'doc-explorer-rhs'
  }, React.createElement('div', {
    className: 'docExplorerHide',
    onClick: hideCodeExporter
  }, "\u2715"))), React.createElement('div', {
    className: 'history-contents',
    style: {
      borderTop: '1px solid #d6d6d6'
    }
  }, snippets.length ? React.createElement(ErrorBoundary, null, React.createElement(CodeExporter, {
    query: query,
    serverUrl: serverUrl,
    snippets: snippets,
    snippet: snippet,
    context: context,
    headers: headers,
    variables: jsonVariables,
    codeMirrorTheme: codeMirrorTheme,
    onSelectSnippet: onSelectSnippet,
    onSetOptionValue: onSetOptionValue,
    optionValues: optionValues || {}
  })) : React.createElement('div', {
    style: {
      fontFamily: 'sans-serif'
    },
    className: 'error-container'
  }, 'Please provide a list of snippets')));
}